import {ScriptStatusOption} from 'components/ScriptStatusSelect';
import {
  ManualChargeMethod,
  PaymentGateway,
  SelectOption,
  CompanyType,
  TransactionOrigin,
  OfferingType,
  ManualPayerType,
  ClientRole,
  NoteSort,
  SyncSource,
} from 'types';
import {TimelineNoteType} from 'types/timeline-note';

export const attemptSelectOptions = [
  {label: '1', value: 1},
  {label: '2', value: 2},
  {label: '3', value: 3},
  {label: '4', value: 4},
  {label: '5+', value: 5},
];

export const MANUAL_PAYMENT_TYPE_OPTIONS: SelectOption<ManualChargeMethod>[] = [
  {label: 'Cash', value: 'cash'},
  {label: 'Zelle', value: 'zelle'},
  {label: 'Wire', value: 'wire'},
  {label: 'Check', value: 'check'},
  {label: 'Other', value: 'other'},
];

export const MANUAL_PAYMENT_TYPE_OPTIONS_LABELS: Record<
  ManualChargeMethod,
  string
> = {
  cash: 'Cash',
  zelle: 'Zelle',
  wire: 'Wire',
  check: 'Check',
  other: 'Other',
};

export const MANUAL_PAYER_TYPE_OPTIONS: SelectOption<ManualPayerType>[] = [
  {label: 'Landlord', value: 'landlord'},
  {label: 'Customer', value: 'customer'},
  {label: 'Property Manager', value: 'property_manager'},
];

export const MANUAL_PAYER_TYPE_OPTIONS_LABELS: Record<ManualPayerType, string> =
  {
    customer: 'Customer',
    landlord: 'Landlord',
    property_manager: 'Property Manager',
  };

export const PAYMENT_GATEWAY_OPTIONS: SelectOption<PaymentGateway>[] = [
  {label: 'Stripe', value: 'stripe'},
  {label: 'Heartland', value: 'heartland'},
];

export const COMPANY_TYPE_OPTIONS: SelectOption<CompanyType>[] = [
  {label: 'Service Provider', value: 'service_provider'},
  {label: 'Property Manager', value: 'property_manager'},
  {label: 'Delivery Manager', value: 'delivery_manager'},
  {label: 'MSP / IT', value: 'msp_provider'},
  {label: 'Reseller', value: 'pickup_dropoff'},
];

export const COMPANY_TYPE_OPTIONS_LABELS: Record<CompanyType, string> = {
  service_provider: 'Service Provider',
  property_manager: 'Property Manager',
  delivery_manager: 'Delivery Manager',
  msp_provider: 'MSP / IT',
  pickup_dropoff: 'Reseller',
};
export const TRANSACTION_ORIGIN_LABELS: Record<TransactionOrigin, string> = {
  pos: 'POS',
  patient_app: 'Patient App',
  payment_link: 'Payment Link',
  dashboard: 'Dashboard',
  driver_app_cod: 'Driver App COD',
};

export const OFFERING_TYPE_OPTIONS_LABELS: Record<OfferingType, string> = {
  service: 'Service',
  product: 'Product',
};

export const CLIENT_ROLES_OPTIONS: SelectOption<ClientRole>[] = [
  {label: 'Customers', value: 'customers'},
  {label: 'Vendors', value: 'vendors'},
];

export const CLIENT_ROLE_LABELS: Record<ClientRole, string> = {
  customers: 'Customers',
  vendors: 'Vendors',
};
export const TIMELINE_SORT_OPTIONS: SelectOption<NoteSort | 'all'>[] = [
  {label: 'All', value: 'all'},
  {label: 'Notes', value: 'notes'},
  {label: 'Transactions', value: 'transactions'},
  {label: 'Messages', value: 'messages'},
  {label: 'Prices', value: 'prices'},
  {label: 'Operations', value: 'operations'},
];

export const TIMELINE_SORT_OPTIONS_LABELS: Record<NoteSort | 'all', string> = {
  all: 'All',
  notes: 'Notes',
  transactions: 'Transactions',
  messages: 'Messages',
  prices: 'Prices',
  operations: 'Operations',
};
export const CUSTOMER_TIMELINE_SORT_OPTIONS: SelectOption<
  'all' | TimelineNoteType
>[] = [
  {label: 'All', value: 'all'},
  {label: 'Notes', value: 'note'},
  {label: 'Messages', value: 'message'},
];

export const CUSTOMER_TIMELINE_SORT_OPTIONS_LABELS: Record<
  'all' | TimelineNoteType,
  string
> = {
  all: 'All',
  note: 'Notes',
  message: 'Messages',
};

export const SYNC_SOURCE_OPTIONS: SelectOption<SyncSource>[] = [
  {label: 'Shopify', value: 'shopify'},
  {label: 'Website Form', value: 'web'},
  {label: 'Dashboard', value: 'dev_testing'},
  {label: 'Client App', value: 'app'},
];
export const SYNC_SOURCE_OPTIONS_LABELS: Record<SyncSource, string> = {
  shopify: 'Shopify',
  web: 'Website Form',
  dev_testing: 'Dashboard',
  app: 'Client App',
};

export const PRIORITY_OPTIONS: SelectOption[] = [
  {
    label: 'High',
    value: 'high',
  },
  {
    label: 'Medium',
    value: 'medium',
  },
  {
    label: 'Low',
    value: 'low',
  },
];
export const PRIORITY_OPTIONS_MAP: Record<string, SelectOption> = {
  high: {label: 'High', value: 'high'},
  medium: {label: 'Medium', value: 'medium'},
  low: {label: 'Low', value: 'low'},
};
export const STATUS_OPTIONS: ScriptStatusOption[] = [
  {value: 'new', label: 'New'},
  {value: 'in_progress', label: 'In-Progress'},
  {value: 'ready_for_dispatch', label: 'Ready for Dispatch'},
  {value: 'completed', label: 'Completed'},
  {value: 'canceled', label: 'Skipped'},
  {value: 'archived', label: 'Archived'},
];
export const STATUS_OPTIONS_MAP: Record<string, SelectOption> = {
  new: {label: 'New', value: 'new'},
  in_progress: {label: 'In-Progress', value: 'in_progress'},
  ready_for_dispatch: {
    label: 'Ready for Dispatch',
    value: 'ready_for_dispatch',
  },
  completed: {label: 'Completed', value: 'completed'},
  canceled: {label: 'Skipped', value: 'canceled'},
  archived: {label: 'Archived', value: 'archived'},
};
export const TIME_OPTIONS: SelectOption[] = [
  {value: 'morning', label: 'Morning'},
  {value: 'afternoon', label: 'Afternoon'},
  {value: 'evening', label: 'Evening'},
];
export const TIME_OPTIONS_MAP: Record<string, any> = {
  morning: {label: 'Morning', value: 'morning'},
  afternoon: {label: 'Afternoon', value: 'afternoon'},
  evening: {label: 'Evening', value: 'evening'},
};

export const PRODUCT_PAYMENT_METHOD_OPTIONS: SelectOption[] = [
  {value: 'cash_on_delivery', label: 'Cash on Delivery'},
  {value: 'digital', label: 'Digital Payment'},
];

export const PRODUCT_PAYMENT_METHOD_OPTIONS_MAP: Record<string, SelectOption> =
  {
    cash_on_delivery: {value: 'cash_on_delivery', label: 'Cash on Delivery'},
    digital: {value: 'digital', label: 'Digital Payment'},
  };

export const INBOX_SORT_OPTIONS: SelectOption[] = [
  {label: 'Most recent', value: 'most_recent'},
  {label: 'Alphabetical', value: 'alphabetical'},
];
